import { render, staticRenderFns } from "./viewPart.vue?vue&type=template&id=2bf945bd&"
import script from "./viewPart.vue?vue&type=script&lang=js&"
export * from "./viewPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/layout/viewPart.vue"
export default component.exports